/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface TasksTaskPermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
}
export const TasksTaskPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TasksTaskPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TasksTaskPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TasksTaskPermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];


